import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Card, Image, Input, Icon, Button } from 'semantic-ui-react';

import Utils from 'utils/Utils.js'
import LoadInline from '../loading/LoadInline.js';
import {colors} from 'style';
import defaultAvatar from 'img/default-avatar.png';

const style = {
    clickable: {
        cursor: 'pointer',
    },
    content: {
        padding: '1px',
        position:'relative',
    },
    segment: {
        maxWidth: '500px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    title: {
        paddingTop: '10px',
        textAlign: 'center',
        color: colors.themeBlue,
        fontSize: '1.2em',
    },
    closeAvatarWrapper: {
        position: 'absolute',
        top: '0',
        left: '0',  
    },
    closeAvatarIcon: {
        position: 'relative',
        right: '-20px',
        top: '-3px',
        width: '12px',
        height: '12px',
        fontSize: '10px',
        margin: '1px',
        padding: '5px',
        backgroundColor: colors.themeMaroon,
        color: '#fff',
        borderRadius: '50%',
    },
    labelImage: {
        width: '35px',
        height: '35px',
        display: 'inline-block', 
        borderRadius: '50%', 
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        backgroundColor:colors.themeBlue,
        margin: '0px 15px 0px 0px',
        opacity: '1',
    },
    imagePositionTeam: {
        position: 'relative',
        top: '13px',
        left: '0px',
    },
    imagePositionRow: {
        position: 'relative',
        top: '2px',
        left: '0px',
    },
    userRow: {
        padding: '10px 5px 10px 5px',
    },
    arrow: {
        float: 'right',
        position: 'relative',
        top: '12px',
    },
    teamInfo: {
        width: '100%',
        height: '100px',
        position: 'absolute',
        top: '0px',
        left: '0px',
        paddingLeft: '10px',
        paddingRight: '10px',
    },
    scrollerContainer: {
        paddingTop: '150px',
    },
    userName: {
        opacity: '0.7',
        position: 'relative',
        top: '-10px',
    },
    team: {
        position: 'relative',
        height: '80px',
        padding: '0px 30px 0px 30px',
    },
    teamMemberName: {
        padding: '10px 0px 0px 0px',
        opacity: '0.7',
        position: 'relative',
        left: '-8px',
        textAlign: 'center',
    },
    me: {
        position: 'absolute',
        top: '0px',
        left: '50%',
        marginLeft: '-50px',
        width: '100px',
        textAlign: 'center',
        clear: 'right',
    },
    user2: {
        cursor: 'pointer',
        float: 'left',
        clear: 'right',
    },
    user3: {
        cursor: 'pointer',
        float: 'right',
        clear: 'right',
    },
    continueButton: {
        display: 'block',
        position: 'absolute',
        bottom: '30px',
        left: '50%',
        marginLeft: '-75px',
        width: '150px',
        borderRadius: '100px',
        backgroundColor: colors.themeTeal,
        color: '#fff',
    }
};

const SelectTeam = ({t,
                     busy,
                     leaderboard,
                     me,
                     user2,
                     user3,
                     keywords,
                     userProfiles,
                     onSelectUser,
                     onDeselectUser,
                     onChangeSearch,
                     onClickContinue,
                     onScroll,
                     setScrollContainer}) => (
    <div className="full-height" style={style.content}>
        <Segment style={style.segment} className='full-height'>
            <div style={style.teamInfo}>
                {leaderboard &&
                    <div style={style.title}>{leaderboard.title}</div>
                }
                <div style={style.team} className='clearfix'>
                    {user2 ? (
                        <div style={style.user2} onClick={()=>onDeselectUser(2)}>
                            <span style={{...style.labelImage, ...style.imagePositionTeam, backgroundImage:'url('+((user2.avatar!=null) ? user2.avatar.url : defaultAvatar)+')'}}>
                                <div style={style.closeAvatarWrapper}>
                                    <i style={style.closeAvatarIcon} className='icon-x' />
                                </div>
                            </span>
                            <div style={style.teamMemberName}>
                                {Utils.titleCase(user2.firstName + ' ' + Utils.limitTo(user2.lastName,1))}
                            </div>
                        </div>
                    ) : (
                        <div style={{...style.user2, cursor:'auto'}}>
                            <span style={{...style.labelImage, ...style.imagePositionTeam, backgroundImage:'url('+defaultAvatar+')'}} />
                        </div>
                    )}

                    {me &&
                        <div style={style.me}>
                            <span style={{...style.labelImage, ...style.imagePositionTeam, backgroundImage:'url('+((me.avatar!=null) ? me.avatar.url : defaultAvatar)+')'}}></span>
                            <div style={style.teamMemberName}>
                                {Utils.titleCase(me.firstName + ' ' + Utils.limitTo(me.lastName,1))}
                            </div>
                        </div>
                    }

                    {user3 ? (
                        <div style={style.user3} onClick={()=>onDeselectUser(3)}>
                            <span style={{...style.labelImage, ...style.imagePositionTeam, backgroundImage:'url('+((user3.avatar!=null) ? user3.avatar.url : defaultAvatar)+')'}}>
                                <div style={style.closeAvatarWrapper}>
                                    <i style={style.closeAvatarIcon} className='icon-x' />
                                </div>
                            </span>
                            <div style={style.teamMemberName}>
                                {Utils.titleCase(user3.firstName + ' ' + Utils.limitTo(user3.lastName,1))}
                            </div>
                        </div>
                    ) : (
                        <div style={{...style.user3, cursor:'auto'}}>
                            <span style={{...style.labelImage, ...style.imagePositionTeam, backgroundImage:'url('+defaultAvatar+')'}} />
                        </div>
                    )}
                </div>
                <hr />
                <Input fluid icon='search' iconPosition='left' value={keywords} onChange={onChangeSearch} />
            </div>

            <div style={style.scrollerContainer} className='full-height'>

                <div className='full-height scrollable' onScroll={onScroll} ref={(el)=>(setScrollContainer(el))}>
                {userProfiles.map((userProfile)=>(
                    <div key={userProfile.id} style={{...style.userRow, ...(!(user2&&user3)&&style.clickable)}} onClick={()=>onSelectUser(userProfile)}>
                        <span style={{...style.labelImage, ...style.imagePositionRow, backgroundImage:'url('+((userProfile.avatar!=null) ? userProfile.avatar.url : defaultAvatar)+')'}}></span>
                        <span style={style.userName}>{Utils.titleCase(userProfile.firstName + ' ' + userProfile.lastName)}</span>
                        <Icon style={style.arrow} className='icon-arrow-right' />
                        <br/>
                    </div>
                ))}
                <LoadInline centered style={{...(busy ? {} : {visibility: 'hidden'})}} /> 
                </div>
            </div>
            {(user2 && user3) &&
                <Button style={style.continueButton} onClick={onClickContinue}>{t('Continue')}</Button>
            }
        </Segment>
    </div>
);

export default translate('teamchallenges')(SelectTeam);



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/SelectTeam.js